var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMembersArea(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94201 1.82073L5.71662 3.15596C3.16374 4.68769 1.8873 5.45356 1.8873 6.58594C1.8873 7.71832 3.16374 8.48418 5.71662 10.0159L7.94202 11.3511C8.94469 11.9528 9.44603 12.2536 10 12.2536C10.554 12.2536 11.0553 11.9528 12.058 11.3511L14.2834 10.0159C16.8363 8.48418 18.1127 7.71832 18.1127 6.58594C18.1127 5.45356 16.8363 4.68769 14.2834 3.15596L12.058 1.82073C11.0553 1.21912 10.554 0.918318 10 0.918318C9.44603 0.918318 8.94469 1.21912 7.94201 1.82073Z",
    stroke: "#848484",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.41406V14.2626C4 15.56 4 16.2088 4.33794 16.7136C4.67587 17.2185 5.27561 17.4659 6.47508 17.9605L8.47508 18.7852C9.22757 19.0955 9.60381 19.2507 10 19.2507C10.3962 19.2507 10.7724 19.0955 11.5249 18.7852L13.5249 17.9605C14.7244 17.4659 15.3241 17.2185 15.6621 16.7136C16 16.2088 16 15.56 16 14.2626V9.41406",
    stroke: "#848484",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1094 6.58594V10.3984",
    stroke: "#848484",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersArea);
export default __webpack_public_path__ + "static/media/members-area.5db3751c.svg";
export { ForwardRef as ReactComponent };